import { useEffect } from 'react';

export const useEscClose = (onClose, active = true) => {
  useEffect(() => {
    if (!active) return;
    const handler = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose, active]);
};

export default useEscClose;
